module.exports = __webpack_public_path__ + "static/assets/eba0ee63102b369f93c59a681cd2f5bf.png";